var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
var useTypedSelector = useSelector;
var WidgetFieldset = function (_a) {
    var children = _a.children, isDisabled = _a.isDisabled;
    var formIsSubmitting = useTypedSelector(function (store) { return store.app; }).formIsSubmitting;
    var formikContext = useFormikContext();
    return (_jsx("fieldset", __assign({ className: "widget-fieldset", disabled: formIsSubmitting || (formikContext === null || formikContext === void 0 ? void 0 : formikContext.isSubmitting) || isDisabled }, { children: children })));
};
export default WidgetFieldset;
